module.exports = (__webpack_require__(4276))(71);


//////////////////
// WEBPACK FOOTER
// delegated ./src/entries/index.js from dll-reference dibs_buyer_layout
// module id = 2321
// module chunks = 63